/**
 * Iter XX.200 — Meta measurement consent bar (Android only).
 *
 * Founder brief: consent-gated Facebook Android SDK init. The bar
 * appears ONCE on Android after TOS has been accepted. Allow → SDK
 * initialises + first App Launch fires within seconds. Decline →
 * SDK stays dormant; the decision is persisted.
 *
 * Not a modal. Slides in as a soft bar above the composer.
 *
 * data-testid: meta-consent-bar / meta-consent-allow / meta-consent-decline
 */
import React from "react";

export default function MetaConsentBar({ onAllow, onDecline }) {
  return (
    <div
      data-testid="meta-consent-bar"
      className="mx-auto max-w-2xl px-4"
    >
      <div
        role="region"
        aria-label="Measurement consent"
        className="mt-2 mb-3 rounded-2xl border border-neutral-800/70 bg-neutral-950/80 backdrop-blur-sm px-4 py-3.5 shadow-md shadow-black/20"
      >
        <div className="text-neutral-100 text-sm leading-snug">
          Help us know which ads bring cricketers to Gully?
        </div>
        <div className="mt-1 text-neutral-400 text-xs leading-relaxed">
          Sends anonymous app-open events to Meta so we can improve who
          finds Gully. You can change your mind anytime in Settings.
        </div>
        <div className="mt-3 flex items-center gap-2">
          <button
            type="button"
            data-testid="meta-consent-allow"
            onClick={onAllow}
            className="rounded-lg bg-emerald-500/15 hover:bg-emerald-500/20 border border-emerald-500/30 text-emerald-200 px-3.5 py-1.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/60"
          >
            Allow
          </button>
          <button
            type="button"
            data-testid="meta-consent-decline"
            onClick={onDecline}
            className="rounded-lg border border-neutral-800 hover:border-neutral-700 text-neutral-300 hover:text-neutral-100 px-3.5 py-1.5 text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-500/60"
          >
            No thanks
          </button>
        </div>
      </div>
    </div>
  );
}
